module.exports = __webpack_public_path__ + "img/customNo.fbfd60e1.png";